import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';

/**
 * Small "back to Main Menu" button. Used on pages that don't use the
 * standard <Header /> (which already includes a home button). Drop next
 * to the page's <h1> so the user can always navigate home in one tap.
 */
const HomeButton = ({ className = '', title = 'Back to Main Menu', testId = 'home-button' }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate('/')}
      className={
        'flex items-center justify-center h-10 w-10 rounded-xl bg-gradient-to-br from-amber-400 to-orange-500 hover:from-amber-500 hover:to-orange-600 text-white shadow-md shadow-amber-500/30 transition-all hover:shadow-lg hover:scale-105 active:scale-95 flex-shrink-0 ' +
        className
      }
      data-testid={testId}
      title={title}
      aria-label={title}
    >
      <Home className="h-4.5 w-4.5" strokeWidth={2.5} />
    </button>
  );
};

export default HomeButton;
